console.log("init Proteus treatments -- v1.06");

// PDP Mobile carousel arrows
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-gallery--mobile-arrows').forEach(function (gallery) {
    const carousel = gallery.querySelector('media-carousel');
    const prevBtn = gallery.querySelector('.carousel-arrow--prev');
    const nextBtn = gallery.querySelector('.carousel-arrow--next');

    if (!carousel || !prevBtn || !nextBtn) return;

    function getVisibleMediaItems() {
      return Array.from(
        carousel.querySelectorAll('.product-gallery__media')
      ).filter(function (el) {
        return el.style.display !== 'none' && !el.classList.contains('hidden');
      });
    }

    function getCurrentIndex() {
      const media = getVisibleMediaItems();
      const rect = carousel.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      let best = 0, bestDist = Infinity;
      for (let i = 0; i < media.length; i++) {
        const r = media[i].getBoundingClientRect();
        if (r.width === 0) continue;
        const d = Math.abs(r.left + r.width / 2 - center);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function updateArrowState() {
      const idx = getCurrentIndex();
      const total = getVisibleMediaItems().length;
      prevBtn.disabled = idx <= 0;
      nextBtn.disabled = idx >= total - 1;
    }

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const idx = getCurrentIndex();
      if (idx <= 0) return;
      const media = getVisibleMediaItems();
      carousel.scrollTo({ left: media[idx - 1].offsetLeft, behavior: 'smooth' });
      setTimeout(updateArrowState, 350);
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const idx = getCurrentIndex();
      const media = getVisibleMediaItems();
      if (idx >= media.length - 1) return;
      carousel.scrollTo({ left: media[idx + 1].offsetLeft, behavior: 'smooth' });
      setTimeout(updateArrowState, 350);
    });

    carousel.addEventListener('scroll', function () {
      updateArrowState();
    }, { passive: true });

    // Reset on variant change
    gallery.addEventListener('variant:change', function () {
      setTimeout(updateArrowState, 100);
    });

    // Also hook into alt2's custom variant update
    document.addEventListener('variant:change', function () {
      setTimeout(updateArrowState, 150);
    });

    updateArrowState();
  });
});

// Fix: carousel height patch
// BaseCarousel._adjustHeight sets max-height:0 when selectedSlide is hidden
(function() {
  function patchCarousel() {
    var carousel = document.querySelector('media-carousel');
    if (!carousel) return false;

    // Patch the prototype (catches future calls)
    var proto = Object.getPrototypeOf(
      Object.getPrototypeOf(
        Object.getPrototypeOf(carousel)
      )
    );

    if (!proto || !proto.hasOwnProperty('_adjustHeight')) return false;

    var original = proto._adjustHeight;

    proto._adjustHeight = function() {
      if (!this.hasAttribute('adaptive-height')) return;

      var slide = this.selectedSlide;

      if (!slide || slide.clientHeight === 0) {
        var items = this.items || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i].clientHeight > 0) {
            slide = items[i];
            break;
          }
        }
      }

      if (slide && slide.clientHeight > 0 && slide.clientHeight !== this.clientHeight) {
        this.style.maxHeight = slide.clientHeight + 'px';
      }
    };

    // Clean up damage from the unpatched first call
    function fixIfBroken() {
      if (carousel.style.maxHeight === '0px' || carousel.offsetHeight === 0) {
        carousel.style.maxHeight = '';
        carousel._adjustHeight();
        
        // If still 0, images haven't loaded yet — wait for them
        if (carousel.style.maxHeight === '0px' || carousel.offsetHeight === 0) {
          carousel.style.maxHeight = '';
        }
      }
    }

    // Run cleanup immediately
    fixIfBroken();

    // Run again after images start loading
    var firstImg = carousel.querySelector(
      '.product-gallery__media:not(.hidden) img'
    );
    if (firstImg) {
      if (firstImg.complete) {
        fixIfBroken();
      } else {
        firstImg.addEventListener('load', fixIfBroken);
      }
    }

    // Safety nets for slow loads
    setTimeout(fixIfBroken, 200);
    setTimeout(fixIfBroken, 500);
    setTimeout(fixIfBroken, 1500);

    // Watch for it happening again (resize, variant switch, etc.)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'style' && carousel.style.maxHeight === '0px') {
          carousel.style.maxHeight = '';
          carousel._adjustHeight();
          if (carousel.style.maxHeight === '0px') {
            carousel.style.maxHeight = '';
          }
        }
      });
    });
    observer.observe(carousel, { attributes: true, attributeFilter: ['style'] });

    return true;
  }

  // Try to patch as early as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Try immediately, then retry
      if (!patchCarousel()) setTimeout(patchCarousel, 50);
    });
  } else {
    if (!patchCarousel()) setTimeout(patchCarousel, 50);
  }
})(); // End Fix: carousel height patch

// set default checkout upsell
if(!window.sessionStorage.getItem("Proteus Checkout Upsell")){
  window.sessionStorage.setItem("Proteus Checkout Upsell", "default-upsell");
  gtm_add_cartAttribute("proteus_checkout_upsell_visibility", "default-upsell");
}

function checkVariantAndTogglePrice() {
  const urlParams = new URLSearchParams(window.location.search);
  const currentVariant = urlParams.get('variant');
  const isFirewoodPage = window.location.pathname.includes('/products/firewood');
  const shouldShowPrice = isFirewoodPage && currentVariant === '43338487693357';
  
  // Remove existing style if it exists
  const existingStyle = document.getElementById('price-toggle-style');
  if (existingStyle) {
    existingStyle.remove();
  }
  
  if (!shouldShowPrice) {
    document.querySelector('body').insertAdjacentHTML("afterbegin", `
      <style id="price-toggle-style">
      .product-info__price{
        display: none;
      }
      </style>  
    `);
  }
}

waitForElement('.shopify_subscriptions_app_container').then(subscription_app => {
  // Initial check
  checkVariantAndTogglePrice();
  
  // Listen for variant changes
  document.addEventListener('variant:change', checkVariantAndTogglePrice);
  
  // Also listen for URL changes (pushstate/popstate)
  window.addEventListener('popstate', checkVariantAndTogglePrice);
  
}).catch();
// support for [BRE-09] PP upsells

/* 
LIDS (prod id: 6578299830317)  
const x19_lid: 39397496324141
const x24_lid: 39397502484525
const x30_lid: 39397505990701

PITS (prod_id: 7219796508717)
X19 / Corten: 41234257870893
X19 / Stainless: 41234257903661
X24 / Corten: 41234325700653
X24 / Stainless: 41234325733421
X30 / Corten: 41234325766189
X30 / Stainless: 41234325798957
X42 / Corten: 41860588306477
X42 / Stainless: 4186059574481
*/

// mapping PIT variant IDs → their matching LID
// Map PIT variant IDs → corresponding LID (product + variant)
const pit_lid_map = {
  // X19 pits
  41234257870893: { prod: 6578299830317, var: 39397496324141 },
  41234257903661: { prod: 6578299830317, var: 39397496324141 },

  // X24 pits
  41234325700653: { prod: 6578299830317, var: 39397502484525 },
  41234325733421: { prod: 6578299830317, var: 39397502484525 },

  // X30 pits
  41234325766189: { prod: 6578299830317, var: 39397505990701 },
  41234325798957: { prod: 6578299830317, var: 39397505990701 },

  // X42 pits: add mapping when you have the LID(s)
  // 41860588306477: { prod: 6578299830317, var: ??? },
  // 4186059574481: { prod: 6578299830317, var: ??? },
};

async function review_shipping(cart) {

  let cart_contents = "";

  for (let i = 0; i < cart.items.length; i++) {
    cart_contents += `${cart.items[i].variant_id}:${cart.items[i].quantity},`;
  }

  var url = "https://admin-api-bre.fly.dev/api/shipping?var_ids=" + encodeURIComponent(cart_contents);
  var response = await fetch(url);

  if (!response.ok) throw new Error("HTTP " + response.status);

  var shipping = await response.json();

  let lbs_30_plus = shipping.shipping_weight.pounds >= 30;

  let pallet_shipping = shipping.shipping_profiles.some(function(obj) {
    return obj.name === "LTL With Pallet Shipping Fee";
  });

  waitForElement("body").then(function(doc) {
    doc.setAttribute(
      "data-shipping-30plus-standard",
      lbs_30_plus && !pallet_shipping
    );
  }).catch(console.error);

  if(lbs_30_plus && !pallet_shipping){
    if(window.sessionStorage.getItem("[BRE-64]") == "v1"){
      gtm_add_cartAttribute('_proteus_discount_1','[BRE-64] poker');
    } else if(window.sessionStorage.getItem("[BRE-64]") == "v3"){
      gtm_add_cartAttribute('_proteus_discount_1','[BRE-64] gloves');
    }
  } else {
    gtm_add_cartAttribute('_proteus_discount_1','');
  }

}

// init
review_shipping(window.cart_data);

document.addEventListener("cart:change", async (event) => {
  window.cart_data = event.detail.cart;

  review_shipping(window.cart_data);

  const lids_to_add = new Set();
  const prods_to_add = new Set();

  for (const item of window.cart_data.items) {
    const match = pit_lid_map[item.variant_id];
    if (match) {
      lids_to_add.add(String(match.var));
      prods_to_add.add(String(match.prod));
    }
  }

  // Build CSV strings; if no matches, set to "none"
  const pp_var_ids  = lids_to_add.size ? Array.from(lids_to_add).join(",") : "none";
  const pp_prod_ids = prods_to_add.size ? Array.from(prods_to_add).join(",") : "none";

  // Desired attributes payload (strings only)
  const desiredAttrs = {
    pp_multi_offer: "true",
    pp_var_ids,
    pp_prod_ids,
    pp_coll_ids: "none",
    pp_discount_amount: "10",
    pp_discount_type: "percentage",
  };

  // (Optional) Skip network call if nothing changes
  const curr = window.cart_data.attributes || {};
  const unchanged =
    curr.pp_multi_offer === desiredAttrs.pp_multi_offer &&
    curr.pp_var_ids === desiredAttrs.pp_var_ids &&
    curr.pp_prod_ids === desiredAttrs.pp_prod_ids &&
    curr.pp_coll_ids === desiredAttrs.pp_coll_ids &&
    curr.pp_discount_amount === desiredAttrs.pp_discount_amount &&
    curr.pp_discount_type === desiredAttrs.pp_discount_type;

  if (unchanged) return;

  try {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes: desiredAttrs }),
    });
    const data = await res.json();
    console.log("Cart attributes updated:", data?.attributes ?? data);
  } catch (err) {
    console.error("Error updating cart:", err);
  }
});


if(getParam("cart") == "open"){
  waitForElement('[aria-controls="cart-drawer"]').then(cart_trigger => {
    cart_trigger.click();
  }).catch()
}

/* START support for [BRE-01] */
let free_burger_press = () => {
  
  window.sessionStorage.setItem("[BRE-01] activate Burger Press GWP", true);
  let burger_press_var_id = 42490257834029;

  // logic for all NOT /cart pages
  let assess_cart = (cart_total) => {

    waitUntil(() => {
      return typeof window.cart_data != "undefined" && typeof window.cart_data.items != "undefined";
    }).then(() => {

      let burger_press_in_cart = window.cart_data.items.some(item => item.title.toLowerCase().includes('breeo burger press'));
      if(!burger_press_in_cart && window.cart_data.total_price >= 39800 && !window.sessionStorage.getItem("[BRE-01] Burger Press GWP added")){
  
        gtm_add_cartAttribute("_proteus_discount_2", "FREE BURGER PRESS")

        setTimeout(() => {

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: burger_press_var_id, 
                quantity: 1
              }]
            })
          }).then(response => response.json()).then(cart => {
            console.log("assess_cart item added"),
            window.sessionStorage.setItem("[BRE-01] Burger Press GWP added", true);
            window.location.href = `/discount/FREEPRESS?redirect=${window.location.pathname}?cart=open`;
          }).catch(error => {
            console.error('Error adding item to cart:', error);
          });

        }, 1500)
        
      }
      
    }).catch();
    
  };

  // init
  assess_cart();

  document.addEventListener('rebuy:cart.change', (event) => { 
    assess_cart(event.detail.cart.subtotal()); 
  });

  document.addEventListener('rebuy:cart.ready', (event) => { 
    // assess_cart(event.detail.cart.subtotal());
  });
  
};

if(window.sessionStorage.getItem("[BRE-01] activate Burger Press GWP") ||
  getParam("free_burger_press") ||
  getParam("utm_campaign").toLowerCase().indexOf("burger press") > -1){
  free_burger_press();
}

window.addEventListener("klaviyoForms", function(e) { 
  console.log("klaviyoForms event", e.detail)
  if (e.detail.type == 'submit' && e.detail.formId == "W2VaPf") {
    free_burger_press();
  }
});
/* END support for [BRE-01] */

/* START support for [BRE-23] */
let activation_param = "pt=firestarter";

const add_item_to_cart = (var_id) =>{
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            items: [
            {
                id: var_id,
                quantity: 1,
                properties: {
                    source: "email signup",
                    _proteus_discount_1: "email signup",
                }
            }
            ]
        })
    }).then(res => res.json()).then(data => {
    console.log('Added to cart:', data);
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    }).catch(err => console.error('Error adding to cart:', err));
}

if(window.sessionStorage.getItem("[BRE-23] in-cart treatment") || window.location.href.indexOf(activation_param) > -1){
    window.sessionStorage.setItem("[BRE-23] in-cart treatment", true);

    

      let review_cart = () => {

        waitForElement('.cart-drawer__line-items').then(cart => {

          let cart_items = cart.querySelectorAll('line-item');
          let show_gwp = false;
          for(let i = 0; i < cart_items.length; i++){
              if(cart_items.length > 0){
                  show_gwp = true;
              }
              if(cart_items[i].innerText.indexOf("source: email signup") > -1){
                  show_gwp = false;
                  break;
              }
          }

          if(show_gwp){
              // an item is in the cart AND not the offer
              console.log("setting it up")
              
              if(document.querySelectorAll('.js-offer').length == 0){
                  cart.insertAdjacentHTML("beforebegin", `
                      <style>
                      .js-offer{
                          background: #e6e4db;
                          margin: 1rem 0;
                          padding: 1rem 1rem 1rem 0;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                      }
                      .js-offer > div:first-child{
                          padding-left: 100px;
                          background: url(https://breeo.com/cdn/shop/files/firestarters-main.png?v=1747254340&width=300) left center no-repeat;
                          background-size: 100px;
                      }
                      .js-offer > div:last-child{
                          text-align: center;
                      }
                      .js-offer > div:last-child span{
                          display: block;
                          font-size: .75rem;
                          margin-top: -.5rem;
                      }
                      .js-offer #gwp-atc{
                          transform: scale(.75)
                      }
                      .button.button--xs{
                        cursor: pointer;
                      }
                      @media(max-width: 525px){
                          .js-offer{
                              display: block;
                          }
                          .js-offer > div:last-child{
                              text-align: left;
                              margin-left: 75px;
                          }        
                          .js-offer #gwp-atc{
                              margin-left: 0;
                          }   
                          .js-offer > div:last-child span{
                              margin-left: 55px;
                          }
                      }
                      </style>
                      <div class="js-offer">
                          <div>
                              Claim your <strong>FREE</strong> Waterproof Fire Starters
                          </div>
                          <div style="min-width: 190px;">
                              <div id="gwp-atc" class="button button--xs">Add to Cart</div>
                              <span>a $20.00 value</span>
                          </div>
                          
                      </div>
                  `)
              }
          } else {
              console.log("tearing it down")
              if(document.querySelectorAll('.js-offer') > 0){
                  document.querySelector('.js-offer').remove();
              }
          }

        }).catch();

      } // review_cart();

      // init
      setTimeout(() => {
          review_cart();
      }, 1500)

      observeSelector('line-item', line_item => {
          review_cart();
      });

      observeSelector('#gwp-atc', gwp_atc => {
          gwp_atc.addEventListener("click", (e) => {
              add_item_to_cart(41451417763885); // firestarters
              gwp_atc.parentNode.style.opacity = 0.5;
              setTimeout(() => {
                  gwp_atc.parentNode.remove();
              }, 750)
          });
      });

    // if activated, BLOCK the popups

    const og_form_id_desktop = "W2VaPf";
    const new_form_id_desktop = "SQYvmN";
    const alt_form_id_desktop = "UmvBFA";

    const select_topmost_ancestor = (element, selector) => {
        if (!element) {
        return null;
        }
    
        // Check if the current element matches the specified selector
        if (!element.closest(selector)) {
        // If it does not match, return the current element
        return element;
        }
    
        // Otherwise, check its parent element recursively
        return select_topmost_ancestor(element.parentElement, selector);
    };

    observeSelector(`form[data-testid="klaviyo-form-${og_form_id_desktop}"], form[data-testid="klaviyo-form-${new_form_id_desktop}"], form[data-testid="klaviyo-form-${alt_form_id_desktop}"]`, kl_form => {
        let popup_container = select_topmost_ancestor(kl_form, '.needsclick[class*="kl-"]')
        popup_container.remove();
        document.body.classList.remove("klaviyo-prevent-body-scrolling");
        setTimeout(() => {
            document.body.classList.remove("klaviyo-prevent-body-scrolling");
        }, 500)
    })

}
/* END support for [BRE-23] */

/* START Father's Day promo */

const in_fathers_day_time_window = () => {
  const now = new Date();

  // Eastern Daylight Time (UTC-4)
  const start = new Date("2026-06-19T06:00:00-04:00");
  const end   = new Date("2026-06-26T23:59:59-04:00");

  return now >= start && now <= end;
}

if(in_fathers_day_time_window &&
  (
    window.location.href.indexOf("fathers_day_promo") > -1 ||
    window.sessionStorage.getItem("fathers day promo")
  )
){

  const review_cart_fd = () => {

    console.log("review_cart_fd()");

    waitUntil(() => {
      return window?.cart_data?.items;
    }).then(() => {

      window.sessionStorage.setItem("fathers day promo", true);

      let discount_attribute = "fathers_day_promo";

      let chair1_prod_id = 7005220241453; // x series
      let chair2_prod_id = 8393430269997; // adirondack
      let tray_var_id = 40619226955821;
      let cupholder_var_id = 40930978267181;

      let chair_qty = 0;
      let tray_qty = 0;
      let cupholder_qty = 0;

      window.fd_gwp_attempted = window.fd_gwp_attempted || false;
      window.fd_gwp_running = window.fd_gwp_running || false;
      window.fd_gwp_added_this_pageload = window.fd_gwp_added_this_pageload || false;

      for (let i = 0; i < window.cart_data.items.length; i++) {

        let item = window.cart_data.items[i];

        if (
          item.product_id == chair1_prod_id ||
          item.product_id == chair2_prod_id
        ) {
          chair_qty += item.quantity;
        }

        if (item.variant_id == tray_var_id) {
          tray_qty += item.quantity;
        }

        if (item.variant_id == cupholder_var_id) {
          cupholder_qty += item.quantity;
        }

      }

      if (chair_qty < 1) {
        return;
      }

      let tray_qty_needed = Math.max(0, chair_qty - tray_qty);
      let cupholder_qty_needed = Math.max(0, chair_qty - cupholder_qty);

      if (
        // !window.fd_gwp_attempted
        !window.fd_gwp_running
        //  && window.cart_data?.attributes?._proteus_discount_1 != discount_attribute
         // && !window.fd_gwp_added_this_pageload
      ) {

        window.fd_gwp_running = true;
        window.fd_gwp_attempted = true;
        window.fd_gwp_added_this_pageload = true;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              _proteus_discount_1: discount_attribute
            }
          })
        }).then(() => {

          let items = [];

          if (tray_qty_needed > 0) {
            items.push({
              id: tray_var_id,
              quantity: tray_qty_needed,
              properties: {
                _proteus_discount_1: discount_attribute
              }
            });
          }

          if (cupholder_qty_needed > 0) {
            items.push({
              id: cupholder_var_id,
              quantity: cupholder_qty_needed,
              properties: {
                _proteus_discount_1: discount_attribute
              }
            });
          }

          if (!items.length) {
            return;
          }

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: items
            })
          });

        }).then(() => {

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true
            })
          );

        }).finally(() => {

          window.fd_gwp_running = false;

        });

      }

    }).catch();
  } // review_cart_fd()

  // init 
  // review_cart_fd();

 document.addEventListener("cart:change", () => {

  setTimeout(() => {
    // review_cart_fd();
  }, 500)
 }) 

}

// START support for [BRE-57]
let LTL_VAR_IDS = new Set([43154118803501, 43154118836269, 43165302718509, 44841056731181, 44841056763949, 44841056796717, 44841056829485, 44841056862253, 44841056895021, 44841056927789, 44841056960557, 44841056993325, 44841057026093, 44841057058861, 44841057091629, 44841057124397, 41234325766189, 41234325798957, 41860588306477, 41860595744813, 42034282037293, 42034282070061, 42044962734125, 42044962766893, 42078013095981, 42078013161517, 42209057898541, 42209057931309, 42209057964077, 42209057996845, 42209058029613, 42209058062381, 42209058095149, 42209058127917, 42209058160685, 42209058193453, 42209058226221, 42209058258989, 42209058291757, 42209058324525, 42209058357293, 42209058390061, 42209058422829, 42209058455597, 42209058488365, 42209058521133, 42233680363565, 42233680396333, 42905059590189, 44780771442733, 44780771475501, 44780771508269, 44780771541037, 42968652808237, 42986449764397, 42986449797165, 42987546837037, 42987546869805, 43129383518253, 43129383551021, 43129388040237, 43129388073005, 43129395150893, 43155906723885, 43155906756653, 43155906789421, 43155906822189, 43155906854957, 43155906887725, 43155906920493, 43155906953261, 43155906986029, 43155907018797, 43155907051565, 43155907084333, 43155910000685, 43155910033453, 43155910066221, 43155910098989, 43155910131757, 43155910164525, 43155910197293, 43155910230061, 43155910262829, 43155910295597, 43155910328365, 43155910361133, 43325045702701, 43325045735469, 43325045768237, 43325045866541, 43325046456365, 43325046489133, 43325046587437, 43325046685741, 43325047668781, 44837884788781, 44837884821549, 44837884887085, 44017263509549, 44017263542317, 44609707474989, 44609707507757, 44609707540525, 44609707573293, 44609707606061, 44609707638829, 44609707671597, 44609707704365, 44609707737133, 44609707769901, 44609707802669, 44609707835437, 44609707868205, 44609707900973, 44609707933741, 44609707966509, 44609707999277, 44609708032045, 44609708064813, 44609708097581, 44609708130349].map(String));
observeSelector('form[action="/cart/add"]', atc_form => {
  setInterval(() => {
    const var_id    = atc_form.querySelector('input[name="id"]');
    const line_prop = atc_form.querySelector('input[name="properties[_discount]"]');
    const isLtl     = var_id && LTL_VAR_IDS.has(var_id.value);   // string vs string ✓

    if (isLtl) {
      if (line_prop) line_prop.value = "LTL Shipping";
      else var_id.insertAdjacentHTML("afterend",
        `<input type="hidden" name="properties[_discount]" value="LTL Shipping">`);
    } else if (line_prop) {
      line_prop.remove();
    }
  }, 500);
});
// END support for [BRE-57]
// ---------------------------------------------------------------------------
// [BRE-61] Control-arm (V0) upsell click tracking — appended 2026-08-10.
// Passive: capture-phase listener only, no DOM mutation, no globals beyond one
// flag. Wrapped in its own try/catch so a failure here cannot affect anything
// above it in this file. Treatment arms (V1/V2/V3) emit their own event from
// the Proteus tag and are explicitly skipped here.
// ---------------------------------------------------------------------------
(function () {
  try {
    if (window.__bre61Track) return;
    window.__bre61Track = true;

    var PITS = {
      'x-series-smokeless-fire-pit': 'X Series',
      'y-series-smokeless-fire-pit': 'Y Series',
      'zentro-round-fire-pit': 'Zentro',
      'luxeve-smokeless-fire-pit': 'Luxeve'
    };
    var key = (location.pathname.split('/products/')[1] || '').split('?')[0].replace(/\/$/, '');
    var line = PITS[key];
    if (!line) return;

    document.addEventListener('click', function (e) {
      try {
        var t = e.target;
        if (!t || !t.closest) return;
        var a = t.closest('a[href*="/products/"], a[href*="/collections/"]');
        if (!a) return;
        if (a.closest('.b61')) return; // treatment arm — already tracked by the tag

        var sec = a.closest('[id^="shopify-section"]');
        if (!sec) return;

        var mod = null;
        if (sec.id.indexOf('__related-products') > -1) {
          mod = 'related_products';
        } else {
          var h = sec.querySelector('h1,h2,h3');
          var txt = h ? (h.textContent || '').trim().toLowerCase() : '';
          if (/choose your experience|shop fire pit bundles/.test(txt)) mod = 'bundles_legacy';
          else if (/complete your setup/.test(txt)) mod = 'complementary_legacy';
        }
        if (!mod) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'bre61_upsell_click',
          bre61_variant: 'V0',
          bre61_line: line,
          bre61_module: mod,
          bre61_destination: a.getAttribute('href')
        });
      } catch (err) { /* never interfere with the click */ }
    }, true);
  } catch (err) { /* no-op */ }
})();
// END [BRE-61] control tracking

// ---------------------------------------------------------------------------
// [BRE-62] Bundle Cover Media Swap
// ---------------------------------------------------------------------------
(function () {
  try {
    if (window.__bre62Init) return;
    window.__bre62Init = true;

    function bre62InScope(scope) {
      var key = (location.pathname.split('/products/')[1] || '').split('?')[0].replace(/\/$/, '');
      return scope.indexOf(key) > -1;
    }

    function bre62CurrentVariantId() {
      var fromUrl = getParam('variant');
      if (fromUrl) return fromUrl;

      var pickerData = document.querySelector('variant-picker script[data-variant]');
      if (pickerData) {
        try {
          var variant = JSON.parse(pickerData.textContent);
          if (variant && variant.id) return variant.id.toString();
        } catch (e) {}
      }
      return null;
    }

    function bre62IsVideoUrl(url) {
      return /\.(mp4|webm|mov|m4v)(\?|$)/i.test(url);
    }

    function bre62SetVideo(img, url) {
      var video = document.createElement('video');
      video.className = img.className;
      video.setAttribute('playsinline', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('preload', 'auto');
      video.setAttribute('data-original-src', url);
      video.muted = true;
      video.autoplay = true;
      video.playsInline = true;

      var source = document.createElement('source');
      source.setAttribute('src', url);
      video.appendChild(source);

      img.parentNode.replaceChild(video, img);

      video.load();
      bre62TryPlay(video);

      return video;
    }

    function bre62TryPlay(video) {
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () { /* autoplay blocked — nothing else to fall back to without controls */ });
      }
    }

    var BRE62_POSTER_CACHE = {};
    function bre62GetVideoPoster(url, callback) {
      if (BRE62_POSTER_CACHE[url]) { callback(BRE62_POSTER_CACHE[url]); return; }

      var video = document.createElement('video');
      video.crossOrigin = 'anonymous';
      video.muted = true;
      video.playsInline = true;
      video.preload = 'auto';

      function capture() {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = video.videoWidth || 300;
          canvas.height = video.videoHeight || 300;
          canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
          var dataUrl = canvas.toDataURL('image/jpeg', 0.8);
          BRE62_POSTER_CACHE[url] = dataUrl;
          callback(dataUrl);
        } catch (e) {
          callback(null);
        }
      }

      video.addEventListener('loadeddata', function () {
        if (video.duration > 0.2) {
          video.addEventListener('seeked', capture, { once: true });
          video.currentTime = Math.max(0, video.duration - 0.1);
        } else {
          capture();
        }
      }, { once: true });

      video.addEventListener('error', function () { callback(null); }, { once: true });
      video.src = url;
    }

    function bre62SwapStaticImg(img, url, isVideo) {
      if (!img) return false;

      if (isVideo) {
        bre62GetVideoPoster(url, function (posterUrl) {
          if (!posterUrl) return;
          img.setAttribute('src', posterUrl);
          img.removeAttribute('srcset');
        });
        return false;
      }

      img.setAttribute('src', url);
      img.removeAttribute('srcset');
      return true;
    }

    function bre62SwapMedia(el, url) {
      if (!el) return null;

      if (bre62IsVideoUrl(url)) {
        if (el.tagName === 'VIDEO') {
          var source = el.querySelector('source');
          if (!source) {
            source = document.createElement('source');
            el.appendChild(source);
          }
          source.setAttribute('src', url);
          el.setAttribute('data-original-src', url);
          el.load();
          bre62TryPlay(el);
          return el;
        }
        return bre62SetVideo(el, url);
      }

      if (el.tagName !== 'IMG') return null;
      el.setAttribute('src', url);
      el.setAttribute('data-original-src', url);
      el.removeAttribute('srcset');
      return el;
    }

    function bre62Swap(config, variantId) {
      if (!bre62InScope(config.scope)) return;

      variantId = variantId || bre62CurrentVariantId();
      var url = variantId && config.assets[variantId];
      if (!url) return;

      var isVideo = bre62IsVideoUrl(url);
      var applied = 0;

      var coverEl = document.querySelector(
        '.product-gallery__media[data-variant-id="' + variantId + '"] img, ' +
        '.product-gallery__media[data-variant-id="' + variantId + '"] video'
      );
      var thumbImg = document.querySelector('.product-gallery__thumbnail[data-variant-id="' + variantId + '"] img');
      var quickAddImg = document.querySelector('.product-quick-add variant-media img');

      if (bre62SwapMedia(coverEl, url)) applied++;
      if (bre62SwapStaticImg(thumbImg, url, isVideo)) applied++;
      if (bre62SwapStaticImg(quickAddImg, url, isVideo)) applied++;

      if (applied > 0) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'bre62_treatment_applied',
          bre62_variant_id: variantId,
          bre62_images_swapped: applied
        });
      }
    }

    function bre62Activate(config) {
      waitUntil(function () {
        return document.querySelectorAll('.product-gallery img, product-gallery img').length > 0;
      }).then(function () {
        bre62Swap(config);

        document.addEventListener('variant:change', function (event) {
          var v = event.detail && event.detail.variant;
          bre62Swap(config, v && v.id ? v.id.toString() : null);
        });
      }).catch(function () {});
    }

    function bre62HandleFromHref(href) {
      var match = href && href.match(/\/products\/([a-z0-9-]+)/i);
      return match ? match[1] : null;
    }

    function bre62TrackCard(handle) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'bre62_treatment_applied', bre62_card_handle: handle });
    }

    function bre62ActivateCards(config) {
      if (!config.cards) return;

      observeSelector('product-card[handle]', function (card) {
        var handle = card.getAttribute('handle');
        var url = config.cards[handle];
        if (!url) return;

        var media = card.querySelector('.product-card__image--primary');
        var result = bre62SwapMedia(media, url);
        if (!result) return;

        if (result.tagName === 'VIDEO') {
          bre62GetVideoPoster(url, function (posterUrl) {
            if (posterUrl) result.poster = posterUrl;
          });
        }

        bre62TrackCard(handle);
      });
    }

    function bre62ActivateSearchResults(config) {
      if (!config.cards) return;

      observeSelector('a.predictive-search-result', function (link) {
        var handle = bre62HandleFromHref(link.getAttribute('href'));
        var url = handle && config.cards[handle];
        if (!url) return;

        var img = link.querySelector('img');
        if (bre62SwapStaticImg(img, url, bre62IsVideoUrl(url))) bre62TrackCard(handle);
      });
    }

    function bre62ActivateQuickBuy(config) {
      observeSelector('product-rerender#quick-buy-modal-content', function (el) {
        var pickerData = el.querySelector('variant-picker script[data-variant]');
        if (!pickerData) return;

        var variantId;
        try {
          var variant = JSON.parse(pickerData.textContent);
          variantId = variant && variant.id ? variant.id.toString() : null;
        } catch (e) { return; }

        var url = variantId && config.assets[variantId];
        if (!url) return;

        var media = el.querySelector('variant-media img');
        if (!bre62SwapStaticImg(media, url, bre62IsVideoUrl(url))) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'bre62_treatment_applied',
          bre62_variant_id: variantId
        });
      });
    }

    function bre62ActivateQuickBuyAdded(config) {
      observeSelector('.quick-buy-drawer__variant > img.quick-buy-drawer__media', function (img) {
        var drawer = img.closest('quick-buy-drawer');
        var handleAttr = drawer && drawer.getAttribute('handle');
        var match = handleAttr && handleAttr.match(/variant=(\d+)/);
        var variantId = match ? match[1] : null;

        var url = variantId && config.assets[variantId];
        if (!url) return; // not one of our 3 products/variants

        if (bre62SwapStaticImg(img, url, bre62IsVideoUrl(url))) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'bre62_treatment_applied',
            bre62_variant_id: variantId
          });
        }
      });
    }

    function bre62ActivateCartLineItems(config) {
      observeSelector('line-item[data-var-id]', function (lineItem) {
        var variantId = lineItem.getAttribute('data-var-id');
        var url = variantId && config.assets[variantId];
        if (!url) return; // not one of our 3 products/variants

        var img = lineItem.querySelector('.line-item__media');
        if (bre62SwapStaticImg(img, url, bre62IsVideoUrl(url))) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'bre62_treatment_applied',
            bre62_variant_id: variantId
          });
        }
      });
    }

    window.activateBRE62 = function (config) {
      if (!config || !config.scope || !config.assets) return;
      bre62Activate(config);
      bre62ActivateCards(config);
      bre62ActivateQuickBuy(config);
      bre62ActivateQuickBuyAdded(config);
      bre62ActivateCartLineItems(config);
      bre62ActivateSearchResults(config);
    };
  } catch (err) { /* no-op */ }
})();
// END [BRE-62] variant cover image swap